export const SPORTS_CONFIG = {
  football: { name: 'Football', icon: 'circle-dot', slug: 'football' },
  basketball: { name: 'Basketball', icon: 'dribbble', slug: 'basketball' },
};

export const MARKET_LABELS = {
  '1x2': '1X2',
  'double-chance': 'Double Chance',
  'over-under-1.5': 'Over/Under 1.5',
  'over-under-2.5': 'Over/Under 2.5',
  'over-under-3.5': 'Over/Under 3.5',
  'btts': 'BTTS',
  'draw-no-bet': 'Draw No Bet',
  'first-half-1x2': 'First Half Winner',
  'winner': 'Match Winner',
  'total-points': 'Total Points O/U',
  'handicap': 'Handicap',
};

export const SELECTION_LABELS = {
  home: '1', draw: 'X', away: '2',
  home_draw: '1X', home_away: '12', draw_away: 'X2',
  over: 'Over', under: 'Under',
  yes: 'Yes', no: 'No',
};

export const NAV_LINKS = [
  { path: '/', label: 'Home' },
  { path: '/football', label: 'Football' },
  { path: '/basketball', label: 'Basketball' },
  { path: '/value-bets', label: 'Value Bets' },
  { path: '/surebets', label: 'Surebets' },
  { path: '/odds-movements', label: 'Odds Movements' },
];

export const COUNTRY_FLAGS = {
  GB: 'gb', ES: 'es', DE: 'de', IT: 'it', FR: 'fr', TR: 'tr',
  US: 'us', EU: 'eu',
};
